<template>
  <div class="flex flex-col gap-8 justify-center items-center h-[70vh]">
    <!-- Decorative: the heading slot already carries the meaning. -->
    <img
      :src="`/illustrations/${onLight ? 'submitted-light' : 'submitted'}.svg`"
      class="w-32 h-32"
      alt=""
      aria-hidden="true"
    />
    <slot name="heading"> </slot>
    <slot name="text"> </slot>
    <slot name="cta"> </slot>
  </div>
</template>

<script setup lang="ts">
  // The illustration's glow is tuned to the surface behind it: everything in the
  // hub sits on dark1 and takes the dark halo, while the embeddable report form
  // renders on white unless `?theme=dark` and needs the pale one.
  withDefaults(defineProps<{ onLight?: boolean }>(), { onLight: false });
</script>
